var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.916,
    height: 23.918,
    viewBox: "0 0 23.916 23.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    "data-name": "Grupo 303",
    transform: "translate(743.283 223.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(-743.283 -223.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elearning-monitor-screen-online-education",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    "data-name": "Caminho 798",
    d: "M-156.619-204.667h-9.232l-.147-.841a2.392,2.392,0,0,0,.568-3.334,2.392,2.392,0,0,0-3.334-.568,2.392,2.392,0,0,0-.568,3.334,2.39,2.39,0,0,0,.568.568l-.147.841h-8.833a1.594,1.594,0,0,0-1.594,1.594v12.357a1.2,1.2,0,0,0,1.2,1.2h9.168v1.2h-2.392a.4.4,0,0,0-.4.4v1.594a.4.4,0,0,0,.4.4h7.972a.4.4,0,0,0,.4-.4v-1.594a.4.4,0,0,0-.4-.4h-2.392v-1.2h9.168a1.2,1.2,0,0,0,1.2-1.2v-12.755A1.2,1.2,0,0,0-156.619-204.667Zm-12.357-2.79a1.594,1.594,0,0,1,1.594-1.594,1.594,1.594,0,0,1,1.594,1.594,1.594,1.594,0,0,1-1.594,1.594A1.594,1.594,0,0,1-168.976-207.457Zm2.316,2.79H-168.1l.084-.486a2.363,2.363,0,0,0,1.276,0Zm2.866,17.14v.8h-7.175v-.8Zm-4.385-.8v-1.2h1.594v1.2Zm11.958-2.392a.4.4,0,0,1-.4.4h-21.525a.4.4,0,0,1-.4-.4v-.4h22.322Zm0-1.2h-22.322v-11.161a.8.8,0,0,1,.8-.8h21.126a.4.4,0,0,1,.4.4Z",
    transform: "translate(179.34 209.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    "data-name": "Caminho 799",
    d: "M37.856-183.417a1.2,1.2,0,0,0,1.2-1.2,1.2,1.2,0,0,0-1.2-1.2,1.2,1.2,0,0,0-1.2,1.2A1.2,1.2,0,0,0,37.856-183.417Zm0-1.594a.4.4,0,0,1,.4.4.4.4,0,0,1-.4.4.4.4,0,0,1-.4-.4A.4.4,0,0,1,37.856-185.012Z",
    transform: "translate(-25.898 187.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M-134.214-81.809h-20.728a.4.4,0,0,0-.4.4v10.364a.4.4,0,0,0,.4.4h20.728a.4.4,0,0,0,.4-.4V-81.41A.4.4,0,0,0-134.214-81.809Zm-11.4,10.364h-7.338v-.4a1.2,1.2,0,0,1,1.2-1.2h.6l1.076,1.435a.4.4,0,0,0,.558.08.4.4,0,0,0,.08-.08l1.076-1.435h.869l.706.5a.377.377,0,0,0,.311.068.383.383,0,0,0,.259-.183l.6-.969.865.646Zm-5.744-6.378h3.189v1.2a1.594,1.594,0,0,1-1.594,1.594,1.594,1.594,0,0,1-1.594-1.594Zm-1.144-.8a1.581,1.581,0,0,1,1.918-1.148,1.582,1.582,0,0,1,.613.307.4.4,0,0,0,.339.076,1.319,1.319,0,0,1,.267-.032,1.2,1.2,0,0,1,1.128.8Zm2.029,4.783.1-.482a2.293,2.293,0,0,0,1.228,0l.1.482Zm1.108.8-.4.53-.4-.53ZM-145.2-74.3l.132-.211a.506.506,0,0,1,.662-.187.515.515,0,0,1,.227.692l-.007.014-.175.315Zm10.591,2.858H-144.7l1.2-2.164a1.287,1.287,0,0,0,.1-1.02,1.227,1.227,0,0,0-.295-.5l1.455-2.91-.71-.359-1.439,2.878a1.3,1.3,0,0,0-1.375.59l-.921,1.5-.462-.327a.375.375,0,0,0-.231-.076h-.869l-.163-.825a2.392,2.392,0,0,0,1.032-1.965v-1.594a1.993,1.993,0,0,0-1.993-1.993,1.945,1.945,0,0,0-.259.02,2.334,2.334,0,0,0-1.335-.419,2.392,2.392,0,0,0-2.392,2.392.4.4,0,0,0,.4.4h.8v1.2a2.392,2.392,0,0,0,1.032,1.965l-.163.825h-.47a1.993,1.993,0,0,0-1.993,1.993v.4h-.8v-9.567h19.93Z",
    transform: "translate(156.536 88.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M116.66-49.809h3.189v.8H116.66Z",
    transform: "translate(-101.912 57.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M196.66-49.809h2.392v.8H196.66Z",
    transform: "translate(-177.925 57.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M116.66-17.809h1.594v.8H116.66Z",
    transform: "translate(-101.912 27.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    "data-name": "Caminho 804",
    d: "M164.66-17.809h3.986v.8H164.66Z",
    transform: "translate(-147.52 27.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    "data-name": "Caminho 805",
    d: "M116.66,14.191h2.392v.8H116.66Z",
    transform: "translate(-101.912 -3.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    "data-name": "Caminho 806",
    d: "M180.66,14.191h3.189v.8H180.66Z",
    transform: "translate(-162.723 -3.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    "data-name": "Caminho 807",
    d: "M116.66,46.191h6.378v.8H116.66Z",
    transform: "translate(-101.912 -33.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    "data-name": "Caminho 808",
    d: "M116.66,78.191h6.378v.8H116.66Z",
    transform: "translate(-101.912 -63.839)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.552f81614b4249de47095653cccbca83.svg";
export { ForwardRef as ReactComponent };